<div class="widget-tile">
  <span>Voeg nieuwe rapportage toe</span>
  <i class="icon-add"></i>
</div>
